import React from "react";
import LandingpageHero from "../../assets/images/researchwire_background.webp";
import "../../styles/home-hero-visual.scss";

/**
 * HomeHeroVisual - Displays the static light theme background image.
 */
const HomeHeroVisual = () => {
  return (
    <div className="home-hero-visual-wrapper">
      <img
        src={LandingpageHero}
        alt="Market Research Background"
        className="hero-background-image"
        fetchPriority="high"
        loading="eager"
      />
    </div>
  );
};

export default HomeHeroVisual;
